<template>
  <div class="stops">
    <div class="main">
      <ul>
        <!--
          v-if="group && group.indexOf(id) > -1" -->
        <li
          class="stop"
          :class="inrange(id) ? 'unlocked' : 'locked'"
          v-for="(id, index) in nearest"
          :key="index">
          <a @click="handleclick(id)">
            <img class="exhibit-pic" :src="exhibitdata[id] ? exhibitdata[id].thumbnail : unknownthumb"/>
            <div class="exhibit-details fontBold">
              <p class="exhibit-name" :id="id" :data-index="index">{{ exhibits[id].name }}</p>
              <!-- <p v-if="$store.state.inzone" class="distance">{{ distance(id) }} feet away </p> -->
            </div>
          </a>
        </li>
      </ul>
    </div>

    <router-link
      v-if="switcherlink.length"
      class="button switcher"
      :to="switcherlink">
      Map
    </router-link>

    <div class="overlay" v-if="toofar">
      <p>You are not close enough.</p>
      <p v-if="$store.state.inzone">{{ distance(currex) }} feet</p>
      <p>
        <button @click="closeoverlay()">Close</button>
      </p>
    </div>

  </div>
</template>

<script>
import UnknownThumb from '../assets/unknown.png'

export default {
  name: 'Stops',
  components: {},
  props: {
    exhibitGroup: {
      type: String,
      default: ''
    },
    switcherlink: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      toofar: false,
      currex: ''
    }
  },
  computed: {
    nearest () {
      //console.log('nearest in stops', this.$store.state.nearest)
      return this.$store.state.nearest
    },
    // the equivalent of ```group && group.indexOf(id) > -1```
    nearestFiltered(){
      const g = this.group
      if (g)
      {
        const all = this.nearest
        return all.filter( item =>{
          return g.indexOf(item) > -1
        })
      }else{
        // no group so no IDs to compare...
        return []
      }
    },

    group () {
      return this.$store.state.exhibit_groups[this.exhibitGroup]
    },
    exhibits () {
      return this.$store.state.exhibits
    },
    exhibitdata () {
      return this.$store.state.exhibit_data
    },
    unknownthumb () {
      return UnknownThumb
    }
  },
  methods: {
    distance (id) {
      return Math.round(this.$store.state.distances[id] * 3.2808)
    },
    link (id) {
      return { name: 'exhibit', params: { exhibitslug: this.exhibits[id].friendly } }
    },
    // determines whether or not to show things based on proximity...
    inrange (id) {
      return true
      // return this.$store.state.distances[id] <= 20
    },
    handleclick (id) {
      if (this.inrange(id)) {
        this.$router.push(this.link(id))
      } else {
        this.toofar = true
        this.currex = id
      }
    },
    closeoverlay () {
      this.toofar = false
      this.currex = ''
    }
  },
  beforeMount () {
    // window.loclyLocation.start()
  }
}
</script>
<style lang="scss" scoped>
.stops {
  position:relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
    li {
      margin: 0;
    }
    li a {
      height: 70px;
      cursor:pointer;

      img {
        height: 100%;
        align-self: center;
      }
      display: flex;
      flex-direction: row;
      padding-right: 30px;
      align-items: center;

      border-bottom: 1px solid #c8c8c8;
      // border-top: none;
      color: black;
      text-decoration: none;

    }

    // .locked {
    //   background: url('../assets/locked.png') no-repeat calc(100% - 10px) center;
    //   background-size: 30px 50px;
    // }

    // .unlocked {
    //   background: url('../assets/unlocked.png') no-repeat calc(100% - 10px) center;
    //   background-size: 30px 50px;
    // }

    .seen {
      background: url('../assets/checked.png') no-repeat calc(100% - 10px) center;
      background-size: 30px 50px;
    }
  }

  .overlay {
    p {
      background: #e2e2e2;
      padding: 10px;
      width: 100%;
      margin: 0;
    }
    background: rgba(255, 255, 255, 0.7);
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position:absolute;
  }


  .exhibit-details {
    margin: 2px;
  }

  .exhibit-pic {
    margin-right: 8px;
  }

  .exhibit-name {
    font-size: 1em;
    font-weight: bold;
    text-transform: capitalize;
    margin:0;
    padding:0;
    // font-family: Arial, sans-serif;
  }

  .exhibit-description {
    font-size: 0.8em;
    font-weight: bold;
    text-transform: uppercase;
    // font-family: Arial, sans-serif;
  }

  .distance {
    font-size: 0.75em;
    font-weight: bold;
    text-transform: lowercase;
    // font-family: Arial, sans-serif;
    margin-top: 5px;
  }

  .top {
    display: flex;
    flex-direction: column;
    justify-content: center;

    height: 100px;
    background-color: #000000;
    color: #FFFFFF;
    font-family: 'adobe-garamond-pro', 'Times New Roman', serif;
    font-size: 3em;
    letter-spacing: 0.1em;
    text-align: center;
    text-transform: uppercase;


  }
  .main {
    flex: 1;
    overflow-y: auto;
    text-align: left;
  }
  .switcher {
    position: absolute;
    bottom: 10px;
    right: 10px;
    padding: 10px;
  }
}
</style>
